module.exports = __webpack_public_path__ + "img/WINE.f4d837c6.png";